import React from 'react';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  useNavigate,
} from 'react-router-dom';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  Spinner,
  Checkout,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import Item from '../Item';

const mapState = state => ({
  clientId: coreSelectors.getProfile('id')(state),
  products: coreSelectors.getResourceMappedList(
    'products',
  )(state),
  setPlanState: coreSelectors.getPaymentRequestsState(
    'setPlanState',
  )(state),
  productPlans: coreSelectors.getResourceMappedList(
    'productPlans',
  )(state),
  subscription: coreSelectors.getSubscription(state),
});

const ClientItems = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    clientId,
    products,
    setPlanState,
    subscription,
    productPlans,
  } = useSelector(mapState, shallowEqual);

  const onSubscribePlan = (planId: number) => {
    dispatch(
      uiActions.setUiState({
        checkoutModal: {
          isOpen: true,
          planId,
        },
      }),
    );
  };

  const onBuyProduct = (productId: number) => {
    const onSuccess = () => {
      dispatch(
        uiActions.setUiState({
          checkoutModal: {
            isOpen: true,
            type: 'buy',
          },
        }),
      );
    };

    dispatch(
      coreActions.requestBuyProduct({
        payload: {
          client_id: clientId,
          product_id: productId,
        },
        callbacks: {
          onSuccess,
        },
      }),
    );
  };

  return (
    <Flex
      column
      flex="0 0 1000px"
      spacing={30}
    >
      {(setPlanState === 'pending') && <Spinner over />}

      {productPlans.map((plan) => (
        <Item
          key={plan.id}
          name={plan.name}
          amount={plan.amount}
          currency={plan.currency}
          interval={plan.interval}
          imageUrl={plan.image?.url}
          videoUrl={plan.video_url}
          isSelected={plan.stripe_id === subscription.plan.id}
          description={plan.description}
          onSubscribe={() => {
            if (plan.stripe_id === subscription.plan.id) {
              navigate('/account/details');
              return;
            }

            onSubscribePlan(plan.id);
          }}
        />
      ))}

      {products.map((product) => (
        <Item
          key={product.id}
          name={product.name}
          amount={product.amount}
          currency={product.currency}
          imageUrl={product.image?.url}
          videoUrl={product.video_url}
          description={product.description}
          onBuy={() => onBuyProduct(product.id)}
        />
      ))}

      <Checkout fetchAfterPay />
    </Flex>
  );
};

export default ClientItems;
